<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wo/feeding/record/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <!--          {{$attrs.appendix.materialId}}-->
          <el-form-item class="noborder" :label="$t('chutangpicihao')">
            <el-input disabled v-model="soupRecord.batchNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chutangshijian')">
            <el-date-picker
              v-model="soupRecord.soupTime"
              type="date"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm:ss"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_cast_management_soup_record_feeding_record',
  props: {
    soupRecord: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      conditions: {
        soupRecordId: this.soupRecord.id
      },
      columns: [
        {
          label: 'touliaoshijian',
          prop: 'feedingTime',
          type: 'time'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },

        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'touliaoren',
          prop: 'feedingUser.nickname'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no'
        },
        {
          label: 'jihuadanhao',
          prop: 'plan.no'
        },


      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 测量值转字符串
    toStr(array) {
      if (!array) {
        return '';
      }
      let str = '';
      for (let i = 0; i < array.length; i++) {
        const a = array[i];
        const s = this.$t('yangben') + `${i + 1}: ${a}`;
        if (i !== array.length - 1) {
          str += s + '<br />';
        } else {
          str += s;
        }
      }
      return str;
    }
  }
};
</script>
